import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createVirtualMachine = async (object) => {
  try {
    return makeGraphQLRequest(
      graphqlOperation(mutations.createVirtualMachine, { input: object })
    );
  } catch (error) {
    console.error("Error creating VirtualMachine:", error);
    throw error;
  }
};

const updateVirtualMachine = async (id, args) => {
  try {
    // First, fetch the current version of the VirtualMachine
    const getVirtualMachineResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getVirtualMachine, { id })
    );
    const currentVirtualMachine =
      getVirtualMachineResponse.data.getVirtualMachine;

    // Prepare the update input
    const updateInput = { id, _version: currentVirtualMachine._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    return makeGraphQLRequest(
      graphqlOperation(mutations.updateVirtualMachine, { input: updateInput })
    );
  } catch (error) {
    console.error("Error updating VirtualMachine:", error);
    throw error;
  }
};

const deleteVirtualMachine = async (id) => {
  try {
    // First, fetch the current version of the VirtualMachine
    const getVirtualMachineResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getVirtualMachine, { id })
    );
    const currentVirtualMachine =
      getVirtualMachineResponse.data.getVirtualMachine;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteVirtualMachine, {
        input: { id, _version: currentVirtualMachine._version },
      })
    );
    return response.data.deleteVirtualMachine;
  } catch (error) {
    console.error("Error deleting VirtualMachine:", error);
    throw error;
  }
};

const getVirtualMachinesByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.virtualMachinesByWorkspace, {
      workspaceID: workspaceID,
    })
  );

export default {
  createVirtualMachine,
  updateVirtualMachine,
  deleteVirtualMachine,
  getVirtualMachinesByWorkspaceID,
};
